export default {
  items: [
    {
      name: "Users",
      url: "/users",
      icon: "fa fa-users fa-lg",
      attributes: { "data-cy": "roles-list" },
    },
    {
      name: "Roles",
      url: "/role",
      icon: "fa fa-stop-circle fa-lg",
      attributes: { "data-cy": "merchants" },
      children: [
        {
          name: "Roles list",
          url: "/roles",
          icon: "fa fa-address-book fa-lg",
          attributes: { "data-cy": "roles-list" },
        },
        {
          name: "Pages",
          url: "/pages",
          icon: "fa fa-stop-circle fa-lg",
          attributes: { "data-cy": "roles-list" },
        },
      ],
    },
    {
      name: "Audit Log",
      url: "/audit-logs",
      icon: "fa fa-file-text fa-lg",
      attributes: { "data-cy": "roles-list" },
    },
  ],
};
